import { render, staticRenderFns } from "./Clusters.vue?vue&type=template&id=7f0170db&scoped=true&"
import script from "./Clusters.vue?vue&type=script&lang=js&"
export * from "./Clusters.vue?vue&type=script&lang=js&"
import style0 from "./Clusters.vue?vue&type=style&index=0&id=7f0170db&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f0170db",
  null
  
)

export default component.exports